<template>
  <div>
    <core-board
      :company="cb_company"
      :user="cb_member"
      :manager="cb_manager"
      :team="cb_team"
      allow-change
      v-on:change="showChange"
      :show-remove="showRemove"
      v-on:remove="remove"
      :sub-title="subTitle"
      :icon="icon"
      :titleOverride="titleOverride"
    ></core-board>
    <change-core-board-dialog
      ref="change"
      v-on:save="change"
    ></change-core-board-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CoreBoard from "@/components/corecard/CoreBoard";
import ChangeCoreBoardDialog from "@/components/corecard/ChangeCoreBoardDialog";
export default {
  name: "ChangableCoreBoard",
  components: { CoreBoard, ChangeCoreBoardDialog },
  props: {
    subTitle: {
      type: String,
      default: "A collection of key metrics for you to review"
    },
    titleOverride: { type: String },
    icon: { type: String }
  },
  data: () => ({
    coreBoardType: null,
    coreBoardId: null,
    member: null,
    team: null
  }),
  computed: {
    showRemove() {
      return this.coreBoardType != this.$enums.coreCardIdTypes.COMPANY;
    },
    cb_company() {
      return this.coreBoardType == this.$enums.coreCardIdTypes.COMPANY
        ? !this._.isEmpty(this.company)
          ? this.company
          : { name: this.profile.companyName }
        : null;
    },
    cb_team() {
      return this.coreBoardType == this.$enums.coreCardIdTypes.TEAM
        ? this.team
        : null;
    },
    cb_member() {
      return this.coreBoardType == this.$enums.coreCardIdTypes.MEMBER
        ? this.member
        : null;
    },
    cb_manager() {
      return this.coreBoardType == this.$enums.coreCardIdTypes.MANAGER
        ? this.member
        : null;
    },
    ...mapGetters({
      teams: "team/teams",
      members: "user/search_users",
      company: "company/company",
      profile: "profile/profile"
    })
  },
  created() {
    this.coreBoardType = this.$enums.coreCardIdTypes.COMPANY;
  },
  methods: {
    showChange() {
      this.$refs.change.showDialog(this.coreBoardType, this.coreBoardId);
    },
    remove() {
      this.change({ id: null, type: this.$enums.coreCardIdTypes.COMPANY });
    },
    change(override) {
      this.coreBoardType = override.type;
      this.coreBoardId = override.id;
      switch (this.coreBoardType) {
        case this.$enums.coreCardIdTypes.MEMBER:
        case this.$enums.coreCardIdTypes.MANAGER:
          this.member =
            override.selected ||
            this.members.find(x => x.id == this.coreBoardId);
          break;
        case this.$enums.coreCardIdTypes.TEAM:
          this.team =
            override.selected || this.teams.find(x => x.id == this.coreBoardId);
          break;
      }
    }
  }
};
</script>
